import Loader from 'components/atoms/Loader';

import s from './styles.module.scss';

export const LoadingRow = () => {
  return (
    <div className={s.loader}>
      <Loader />
    </div>
  );
};
